import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class HaHelpVideoServiceService {

  constructor(private http: HttpClient) { }

  getAllVideosNCategories() {
    return this.http.get(globalAdd.Paneladdress + 'api/HA/VideoMgm/getAllVideosNCategories');
  }

}
